import { useState, useEffect, useCallback } from 'react';
import { getDocuments } from '../firebase/firestore';

// Hook to fetch blog articles from Firestore
export function useBlog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPublished = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      // Fetch published articles (no orderBy to avoid index requirement)
      const docs = await getDocuments('articles', [
        { type: 'where', field: 'published', operator: '==', value: true },
      ]);
      // Sort by date descending (newest first) on client side
      docs.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
      setPosts(docs);
    } catch (err) {
      console.error('useBlog fetchPublished error', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPublished();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPublished = useCallback(() => posts.filter((p) => p.published), [posts]);

  const getBySlug = useCallback(async (slug) => {
    // if we've already loaded posts, search locally
    if (posts.length > 0) {
      return posts.find((p) => p.slug === slug) || null;
    }

    try {
      const docs = await getDocuments('articles', [
        { type: 'where', field: 'published', operator: '==', value: true },
      ]);
      docs.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
      setPosts(docs);
      return docs.find((p) => p.slug === slug) || null;
    } catch (err) {
      console.error('useBlog getBySlug error', err);
      return null;
    }
  }, [posts]);

  return { posts, loading, error, fetchPublished, getPublished, getBySlug };
}
